import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";
import { SERVICES } from "@/data/content";

export default function Services() {
  return (
    <div data-testid="services-page">
      <Seo
        title="Services"
        path="/services"
        description="Explore our services — laser hair removal, custom & Korean facials, IPL skin rejuvenation, waxing, threading, brows, cosmetic treatments and ear piercing in Nepean, Ottawa."
      />
      <PageHero
        script="our services"
        title="Tailored treatments."
        subtitle="From advanced laser hair removal to custom Korean facials, every service is designed to enhance your natural beauty with care and precision."
      />

      <section className="mx-auto max-w-[1400px] px-5 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 2) * 0.08}>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className="group block"
              >
                <div className="relative aspect-[16/10] overflow-hidden rounded-2xl bg-[#f5f5f4]">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute right-4 top-4 flex h-11 w-11 items-center justify-center bg-white/90 backdrop-blur opacity-0 translate-y-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0">
                    <ArrowUpRight size={18} />
                  </div>
                </div>
                <div className="mt-5 flex items-baseline justify-between border-t border-black/12 pt-5">
                  <h2 className="font-serif-display text-3xl md:text-4xl tracking-tight">
                    {s.title}
                  </h2>
                  <span className="text-xs text-[#999]">0{i + 1}</span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-[#3d3d3d]">{s.tagline}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
